module.exports = __webpack_public_path__ + "ffb9bd7684ed79d15f93fbd0b3148ce6.svg";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/LeagueGothic/leaguegothic-italic-webfont.svg
// module id = 431
// module chunks = 0